import script from "./EditorRichText.vue?vue&type=script&setup=true&lang=js"
export * from "./EditorRichText.vue?vue&type=script&setup=true&lang=js"

import "./EditorRichText.vue?vue&type=style&index=0&id=4547bf5b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4547bf5b"]])

export default __exports__